import { render, staticRenderFns } from "./splitpane.vue?vue&type=template&id=795083f6&"
import script from "./splitpane.vue?vue&type=script&lang=js&"
export * from "./splitpane.vue?vue&type=script&lang=js&"
import style0 from "./splitpane.vue?vue&type=style&index=0&id=795083f6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports